import { Controller } from "@hotwired/stimulus"

// Tabs for the operations section: three surfaces, one panel visible.
//
// Markup — the id wiring is required, not decorative. Without aria-controls and
// aria-labelledby a screen reader cannot tell which panel belongs to which tab.
// Panels take tabindex="0" because they hold no focusable element of their own,
// so without it a keyboard user tabs straight past the content:
//
//   <section data-controller="marketing-tabs">
//     <div role="tablist" aria-label="Operational screens">
//       <button role="tab" id="ops-tab-0" aria-controls="ops-panel-0"
//               aria-selected="true" tabindex="0"
//               data-action="click->marketing-tabs#show keydown->marketing-tabs#key"
//               data-marketing-tabs-target="tab">…</button>
//     </div>
//     <div class="mk-panel" id="ops-panel-0" role="tabpanel" tabindex="0"
//          aria-labelledby="ops-tab-0" data-on="true"
//          data-marketing-tabs-target="panel">…</div>
//
// Tab order in the markup must match panel order; selection is by index.
//
// No-JS fallback: the first panel ships with data-on="true", so the section is
// never empty when JS fails.
export default class extends Controller {
  static targets = ["tab", "panel"]

  show(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)
    if (index >= 0) this.select(index)
  }

  // Left/right arrows move between tabs, per the tablist pattern.
  key(event) {
    const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key]
    if (!step) return
    event.preventDefault()
    const count = this.tabTargets.length
    const next = (this.tabTargets.indexOf(event.currentTarget) + step + count) % count
    this.select(next)
    this.tabTargets[next].focus()
  }

  select(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute("aria-selected", String(i === index))
      tab.setAttribute("tabindex", i === index ? "0" : "-1")
    })
    this.panelTargets.forEach((panel, i) => {
      panel.setAttribute("data-on", String(i === index))
    })
  }
}
